import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'
/**
 * Form constants
 */


const GRADING_COMPONENTS = 'grading_components'
const COMMENT = 'comment'
const FINAL = 'final'
const BONUS_POINTS = 'bonus_points'
const REPORTED_TIME = 'reported_time'
const OBSERVATION = 'observation'
const OBSERVED_AT = 'observed_at'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [GRADING_COMPONENTS]: {
      label: `${t('common.objectives')}`,
      name: GRADING_COMPONENTS,
      // required: true,
    },
    [COMMENT]: {
      label: `${t('common.assessment-feedback')}`,
      name: COMMENT
    },
    [FINAL]: {
      label: `${t('assignments.final-grade')}`,
      name: FINAL,
      type: 'number'
    },
    [BONUS_POINTS]: {
      label: `${t('common.bonus-points-active-participation')}`,
      name: BONUS_POINTS,
      type: 'number'
    },
    [REPORTED_TIME]: {
      label: `${t('common.reported-time')}`,
      name: REPORTED_TIME,
      type: 'number'
    },
    [OBSERVATION]: {
      label: `${t('ledger.observation')}`,
      name: OBSERVATION
    },
    [OBSERVED_AT]: {
      label: `${t('ledger.observed-at')}`,
      name: OBSERVED_AT
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [GRADING_COMPONENTS]: [],
  [COMMENT]: '',
  [FINAL]: '',
  [BONUS_POINTS]: '',
  [REPORTED_TIME]: '',
  [OBSERVATION]: '',
  [OBSERVED_AT]: null
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [FINAL]: yup.string(),
    [COMMENT]: yup.string()
  })

export default formModel
